import { render, staticRenderFns } from "./confirm-mail-2.vue?vue&type=template&id=56bd2442&scoped=true&"
import script from "./confirm-mail-2.vue?vue&type=script&lang=js&"
export * from "./confirm-mail-2.vue?vue&type=script&lang=js&"
import style0 from "./confirm-mail-2.vue?vue&type=style&index=0&id=56bd2442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd2442",
  null
  
)

export default component.exports